<template>
  <pt-order-handle-table class="pt-order-handle-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize" @size-change="handelSizeChange" :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" :status="status" v-on="$listeners" :isSelect="isSelect">
    <slot />
  </pt-order-handle-table>
</template>

<script>
import PtOrderHandleTable from './index'
export default {
  name: 'pt-order-handle-table__withData',
  components: {
    'pt-order-handle-table': PtOrderHandleTable
  },
  data () {
    return {
      pageSize: 24,
      totalNumber: 0,
      tableData: [],
      currentParams: {}
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    status: {
      type: String,
      required: true
    },
    tableLabels: {
      type: Array,
      default: () => []
    },
    isSelect: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    status (val, old) {
      this.$refs.table.reload()
    }
  },
  methods: {
    handelSizeChange (val) {
      this.pageSize = val
      this.$refs.table.reload()
    },
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params.pageable['page'] = this.page || page
        params.pageable['size'] = this.pageSize
        return params
      } else {
        return {
          status: this.status.split(','),
          pageable: { page: this.page || page, size: this.pageSize, sort: ['createdDate,asc'] }
        }
      }
    },
    getDataList (page, next) {
      // let data = {
      //   status: this.status.split(','),
      //   pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
      // }
      let data = this.buildFilterParams(page, this.currentParams)
      if (this.$route.query.plateId) {
        data.plateId = this.$route.query.plateId
      }
      if (this.$route.query.rootPlateId) {
        data.rootPlateId = this.$route.query.rootPlateId
      }
      if (data.status[0] === 'CREATE') {
        data.orderActions = 'CREATE'
        data.status = ['ACTION_REQUIRED']
      }
      this.$store.dispatch('orderHandleList', data).then(res => {
        if (next) {
          next(res.data)
        }
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    // 筛选数据的参数,不传默认为{}
    reload (params = {}) {
      this.currentParams = params
      this.$refs.table.reload()
    },
    updateSelected (row) {
      this.$refs.table.updateSelected(row)
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    }
  }
}
</script>
